/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategicGoalMilestoneSecondaryStatusUpdate', 'model/StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StrategicGoalMilestoneSecondaryStatusUpdate'), require('../model/StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicGoalMilestoneSecondaryStatusUpdateApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategicGoalMilestoneSecondaryStatusUpdate, root.ForStractionServiceApi.StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice);
  }
}(this, function(ApiClient, StrategicGoalMilestoneSecondaryStatusUpdate, StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice) {
  'use strict';

  /**
   * StrategicGoalMilestoneSecondaryStatusUpdate service.
   * @module api/StrategicGoalMilestoneSecondaryStatusUpdateApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StrategicGoalMilestoneSecondaryStatusUpdateApi. 
   * @alias module:api/StrategicGoalMilestoneSecondaryStatusUpdateApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the strategicGoalMilestoneSecondaryStatusUpdateAddPut operation.
     * @callback module:api/StrategicGoalMilestoneSecondaryStatusUpdateApi~strategicGoalMilestoneSecondaryStatusUpdateAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestoneSecondaryStatusUpdate} body 
     * @param {module:api/StrategicGoalMilestoneSecondaryStatusUpdateApi~strategicGoalMilestoneSecondaryStatusUpdateAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.strategicGoalMilestoneSecondaryStatusUpdateAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneSecondaryStatusUpdateAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneSecondaryStatusUpdateAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StrategicGoalMilestoneSecondaryStatusUpdate/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneSecondaryStatusUpdateSearchSlicePut operation.
     * @callback module:api/StrategicGoalMilestoneSecondaryStatusUpdateApi~strategicGoalMilestoneSecondaryStatusUpdateSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestoneSecondaryStatusUpdate} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/StrategicGoalMilestoneSecondaryStatusUpdateApi~strategicGoalMilestoneSecondaryStatusUpdateSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice}
     */
    this.strategicGoalMilestoneSecondaryStatusUpdateSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneSecondaryStatusUpdateSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneSecondaryStatusUpdateSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice;

      return this.apiClient.callApi(
        '/StrategicGoalMilestoneSecondaryStatusUpdate/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
